<template>
  <div>
    <b-navbar sticky class="exam__navbar">
      <template v-if="examResponse.exam">
      <b-navbar-brand :to="is_room ? {name: 'thi-thu-lich-su'} : { name: 'exam-detail', params: { id: examResponse.exam.id, slug : examResponse.exam.slug } }" class="exam__back">
        <fa-icon icon="long-arrow-alt-left" /> Trở lại
      </b-navbar-brand>
      </template>

      <b-navbar-nav>
        <b-nav-text class="exam__title">{{ examDetail.name }}</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <template v-if="isLoading">
      <div class="text-center my-5" style="min-height: 50vh">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        
        <div>Loading...</div>
      </div>
    </template>
    <template v-else>
      <div class="exam__result">
        <b-container fluid>
          <b-row class="justify-content-md-center">
            <b-col cols="10" :md=8 :lg=6 :xl=4>
              <div class="exam__result__content py-5">
                <h3 class="text-center">Kết quả bài thi</h3>

                <h5 class="text-center">{{ examDetail.name }}</h5>

                <p class="text-center">Thời gian {{ examDetail.time }} phút</p>

                <b-table-simple hover small caption-top responsive>
                  <b-thead head-variant="dark">
                    <b-tr>
                      <b-th>Kỹ năng</b-th>
                      <b-th class="text-right">Số câu</b-th>
                      <b-th class="text-right">Điểm</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="skill in examResponse.result" :key="skill.id">
                      <b-td>{{ skill.name }}</b-td>
                      <b-td class="text-right">{{ skill.total_correct }}/{{ skill.total_questions }}</b-td>
                      <b-td class="text-right">{{ Math.floor(skill.scores) }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-td>Tổng điểm</b-td>
                      <b-td></b-td>
                      <b-td class="text-right">{{ Math.floor(examResponse.point) }}</b-td>
                    </b-tr>
                  </b-tbody>
                  <b-tfoot>
                    <b-tr>
                      <b-td colspan="7" variant="secondary" class="text-center">
                        <h4>{{ ((examResponse.point >= examDetail.rank.point) ? 'Bạn đã vượt qua bài thi' : 'Bạn chưa vượt qua bài thi') }}</h4>
                        <em>Điểm đạt điều kiện <strong>{{ examDetail.rank.point }}</strong> điểm</em>
                      </b-td>
                    </b-tr>
                  </b-tfoot>
                </b-table-simple>

                <div class="text-center">
                  <b-link class="btn__normal" :to="{ name: 'exam-result-detail', params: { id: id } }">Xem chi tiết</b-link>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { STORE_KEY } from '../_store/constants'

export default {
  name: 'ExamResult',
  data() {
    return {
      id: this.$route.params.id,
      is_room: false
    }
  },
  computed: {
    ...mapGetters({
      examDetail: `${STORE_KEY}/examDetail`,
      examIndexList: `${STORE_KEY}/examIndexList`,
      examResponse: `${STORE_KEY}/examResponse`,
      isLoading: `${STORE_KEY}/isLoading`,
    })
  },
  beforeMount() {
    this.getExamResponse(this.id);
  },
  watch: {
    examDetail () {
      this.is_room = this.examDetail.is_room
    }
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ['getExamResponse']),
    getSkillPoint(id) {
      let point = null
      
      if (this.examResponse) {
        this.examResponse.result.forEach(item => {
          if (item.id == id) {
            point = item.point
          }
        })
      }

      return point
    }
  }
};
</script>